export default __webpack_public_path__ + "static/media/cloneIcon.4015ce61.svg";